/* tslint:disable */
/* eslint-disable */
/**
 * Survey
 * 現地調査用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetCostcoProducts200ResponseAllOfData } from './GetCostcoProducts200ResponseAllOfData';
import {
    GetCostcoProducts200ResponseAllOfDataFromJSON,
    GetCostcoProducts200ResponseAllOfDataFromJSONTyped,
    GetCostcoProducts200ResponseAllOfDataToJSON,
} from './GetCostcoProducts200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetCostcoProducts200Response
 */
export interface GetCostcoProducts200Response {
    /**
     * 
     * @type {GetCostcoProducts200ResponseAllOfData}
     * @memberof GetCostcoProducts200Response
     */
    data: GetCostcoProducts200ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof GetCostcoProducts200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the GetCostcoProducts200Response interface.
 */
export function instanceOfGetCostcoProducts200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function GetCostcoProducts200ResponseFromJSON(json: any): GetCostcoProducts200Response {
    return GetCostcoProducts200ResponseFromJSONTyped(json, false);
}

export function GetCostcoProducts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCostcoProducts200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetCostcoProducts200ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function GetCostcoProducts200ResponseToJSON(value?: GetCostcoProducts200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetCostcoProducts200ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

